export const pppSections = {
  PEOPLE: {
    id: 'people',
    labelId: 'kpi.people.name',
    headlineId: 'kpi.people.headline',
    headlineFocusId: 'kpi.people.headlineFocus',
    copyId: 'kpi.people.copy',
    color: '#3795ff',
  },
  PLANET: {
    id: 'planet',
    labelId: 'kpi.planet.name',
    headlineId: 'kpi.planet.headline',
    headlineFocusId: 'kpi.planet.headlineFocus',
    copyId: 'kpi.planet.copy',
    color: '#23ffa6',
  },
  PROFIT: {
    id: 'profit',
    labelId: 'kpi.profit.name',
    headlineId: 'kpi.profit.headline',
    headlineFocusId: 'kpi.profit.headlineFocus',
    copyId: 'kpi.profit.copy',
    color: '#f3ff00',
  },
};

export function getPPPColorOfUser(user) {
  let pppColor = pppSections.PEOPLE.color;

  if (
    user.planetPercentagesValue > user.peoplePercentagesValue &&
    user.planetPercentagesValue > user.profitPercentagesValue
  ) {
    pppColor = pppSections.PLANET.color;
  }

  if (
    user.profitPercentagesValue > user.peoplePercentagesValue &&
    user.profitPercentagesValue > user.planetPercentagesValue
  ) {
    pppColor = pppSections.PROFIT.color;
  }
  return pppColor;
}
